_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "20a2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("nOHt")


/***/ }),

/***/ "8dkK":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__("easm");
      }
    ]);
  

/***/ }),

/***/ "GUb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAlgoliaCrossSellConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAlgoliaConfig; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);

var algolia = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig.algolia;
var algoliaOptions = {
  appId: algolia.appId,
  apiKey: algolia.apiKey,
  indexName: algolia.productIndex.name,
  filters: algolia.productIndex.filters,
  sortIndices: algolia.productIndex.sortIndices,
  facets: algolia.productIndex.facets,
  pageSize: algolia.productIndex.pageSize
};
function getAlgoliaCrossSellConfig(productType) {
  var appId = algoliaOptions.appId,
      apiKey = algoliaOptions.apiKey;
  var _algolia$crossSellInd = algolia.crossSellIndex,
      indexName = _algolia$crossSellInd.name,
      facets = _algolia$crossSellInd.facets;
  return {
    appId: appId,
    apiKey: apiKey,
    indexName: indexName,
    facets: facets[productType] || {}
  };
}
function createAlgoliaConfig(clientQueryString) {
  return {
    clientQueryString: clientQueryString,
    options: algoliaOptions,
    isEnabled: true
  };
}

/***/ }),

/***/ "easm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ODXe");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cIxt");
/* harmony import */ var _grandvision_search__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ibnq");
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("k3MI");
/* harmony import */ var _util_algolia__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("GUb4");







var _publicRuntimeConfig$, _publicRuntimeConfig$2, _publicRuntimeConfig$3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_6___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var defaultLocale = (_publicRuntimeConfig$ = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.defaultLocale) !== null && _publicRuntimeConfig$ !== void 0 ? _publicRuntimeConfig$ : 'en-GB';
var staticsUrl = (_publicRuntimeConfig$2 = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : (_publicRuntimeConfig$3 = publicRuntimeConfig.grandvision) === null || _publicRuntimeConfig$3 === void 0 ? void 0 : _publicRuntimeConfig$3.staticsUrl) !== null && _publicRuntimeConfig$2 !== void 0 ? _publicRuntimeConfig$2 : '';

var SearchPage = function SearchPage(_ref) {
  var algoliaConfig = _ref.algoliaConfig,
      _ref$queryParams = _ref.queryParams,
      queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams;

  var _useIntl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_10__[/* useIntl */ "Q"])(),
      getLabel = _useIntl.getLabel;

  var _useBloomreachProduct = Object(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* useBloomreachProductRoutes */ "p"])(),
      _useBloomreachProduct2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_useBloomreachProduct, 2),
      formatProductUrl = _useBloomreachProduct2[1].formatProductUrl;

  var amountOfHitsLabel = getLabel('search.results.amount.title');
  var pageTitle = queryParams.q ? "".concat(getLabel('search.results.title'), " '").concat(queryParams.q, "'") : getLabel('search.pageTitle');
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* CmsContainerPage */ "d"], {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_search__WEBPACK_IMPORTED_MODULE_9__[/* AlgoliaConfigProvider */ "a"], _objectSpread(_objectSpread({}, algoliaConfig), {}, {
      NextRouter: next_router__WEBPACK_IMPORTED_MODULE_7___default.a,
      children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsxs"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* CmsPageLayout */ "g"], {
        children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* CmsHeadTags */ "f"], {
          title: pageTitle,
          noIndex: true,
          noFollow: true
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* CmsComponentSlot */ "c"], {
          path: "main/top-container"
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])("div", {
          className: "search-page",
          children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_search__WEBPACK_IMPORTED_MODULE_9__[/* AlgoliaSearch */ "b"], {
            children: function children(stateResults) {
              var _stateResults$searchR;

              return stateResults && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsxs"])(react__WEBPACK_IMPORTED_MODULE_5___default.a.Fragment, {
                children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_search__WEBPACK_IMPORTED_MODULE_9__[/* SearchPageHeader */ "g"], {
                  pageTitle: pageTitle,
                  hitTitle: "".concat((_stateResults$searchR = stateResults.searchResults) === null || _stateResults$searchR === void 0 ? void 0 : _stateResults$searchR.nbHits, " ").concat(amountOfHitsLabel)
                }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_search__WEBPACK_IMPORTED_MODULE_9__[/* ConnectedProductListing */ "c"], {
                  formatProductUrl: formatProductUrl,
                  staticsUrl: staticsUrl
                })]
              });
            }
          })
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_8__[/* CmsComponentSlot */ "c"], {
          path: "main/bottom-container"
        })]
      })
    }))
  });
};

SearchPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(_ref2) {
    var _req$locale;

    var req, algoliaConfig;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref2.req;
            _context.next = 3;
            return Object(_grandvision_search__WEBPACK_IMPORTED_MODULE_9__[/* fetchAlgoliaConfig */ "h"])(_objectSpread(_objectSpread({}, Object(_util_algolia__WEBPACK_IMPORTED_MODULE_11__[/* createAlgoliaConfig */ "a"])(req.originalUrl)), {}, {
              locale: ((_req$locale = req.locale) === null || _req$locale === void 0 ? void 0 : _req$locale.toString()) || defaultLocale,
              ruleContexts: ['search']
            }));

          case 3:
            algoliaConfig = _context.sent;
            return _context.abrupt("return", {
              queryParams: req.query,
              algoliaConfig: algoliaConfig
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (SearchPage);

/***/ })

},[["8dkK",1,2,4,6,5,3,0,7,8,10]]]);